import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const RoomBuilding = () => {
  return (
    <>
   <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'>Room and Building Digital Twins</Card.Title>
                    <Card.Text className='architectural-modeling-text'>
                    Digital twins don’t have to be machines — they can also be spaces. Home offices, conference centers, historical sites, shopping centers, and more can be turned into 3D experiences. Digital twins allow someone from across the globe to tour a campus, see historical sites, join a conference, have a virtual shopping experience, tour museums, and more. To provide our clients with a virtual tour of our Nepal development center, we created a n exact digital twin of our offices and workstations. Developed as a multi - user VR experience, clients can meet our engineers and artists directly in their offices without physical travel.                  
                    </Card.Text>
                    <Row>
                        <Col md={{span:8, offset:2}}>

                    <CardGroup className='amazon-books-cardgroup'>
                        <Row>
                            <Col md={{span:5, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={process.env.PUBLIC_URL + "assets/digital-twin/room-building/images/rb_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:7, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={process.env.PUBLIC_URL + "assets/digital-twin/room-building/images/rb_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                    <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:5, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={process.env.PUBLIC_URL + "assets/digital-twin/room-building/images/rb_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:7, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={process.env.PUBLIC_URL + "assets/digital-twin/room-building/images/rb_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default RoomBuilding
